<ca-modal-container modalTitle="{{ title }}" (dismiss)="dismiss()" data-uit="edit-studyId-dialog">
    <form [formGroup]="formGroup" (ngSubmit)="submit()" novalidate>
        <div class="mb-5">
            <div class="mb-3">{{ selectedFiles }}</div>
            <div *ngIf="hasStudyID" class="mb-4 text-warning">
                {{ 'UPLOAD_MED_FILES_DIALOG.WARNINGS.STUDY_ID_ALREADY_EXISTS' | translate }}
            </div>
            <div class="d-flex flex-column-reverse position-relative">
                <small *ngIf="formGroup.get('value')?.dirty && formGroup.get('value')?.hasError('required')" class="invalid-feedback">
                    {{ 'GENERAL.REQUIRED_FIELD' | translate }}
                </small>
                <input
                    id="study-id-input"
                    type="text"
                    class="form-control position-relative"
                    formControlName="value"
                    required
                    data-uit="studyId-input"
                    [placeholder]="placeholder"
                    (input)="onInputChange()"
                    [ngClass]="formGroup.get('value')?.errors && formGroup.get('value')?.dirty ? 'has-error' : ''"
                />
                <label for="study-id-input">{{ inputLabel }}</label>
            </div>
        </div>
        <div class="mt-4 d-flex">
            <button type="button" caAutoFocus class="btn btn-secondary w-50 me-2" data-uit="studyId-cancel-button" (click)="dismiss()">
                {{ cancelText }}
            </button>
            <button type="submit" caAutoFocus class="btn btn-primary w-50" [disabled]="!isTyping" (click)="submit()" data-uit="studyId-confirm-button">
                {{ confirmText }}
            </button>
        </div>
    </form>
</ca-modal-container>
